module.exports = __webpack_public_path__ + "static/media/general.5014cc85.svg";